const filterTypes = {
  SET_FILTER: 'SET_FILTER',
  SET_TIME_FRAME: 'SET_TIME_FRAME',
  CLEAR_FILTER: 'CLEAR_FILTER',
}

export default filterTypes;